import styled from 'styled-components'

import { Icon as DefaultIcon } from '@/components/ui/icon'

export const Container = styled.div(({ theme }) => ({
  alignItems: 'center',
  background: theme.colors.visitorParkingBg,
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
}))

export const PhotoContainer = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.visitorParkingPhotoBg,
  flexGrow: 1,
  height: '100%',
  objectFit: 'cover',
  position: 'relative',
  width: '100%',
}))

export const Photo = styled.img({
  bottom: 0,
  height: '100%',
  left: 0,
  objectFit: 'contain',
  objectPosition: 'center bottom',
  position: 'absolute',
  width: '100%',
})

export const VisitorParkingTitle = styled.h1(({ theme }) => ({
  color: theme.colors.white,
  fontSize: '4rem',
  fontWeight: 700,
  left: 0,
  position: 'absolute',
  textAlign: 'center',
  top: theme.space['50'],
  width: '100%',
}))

export const Content = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.visitorParkingBg,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  padding: `${theme.space['28']} ${theme.space['28']} ${theme.space['36']} ${theme.space['28']}`,
}))

export const Heading = styled.h1(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '2.6rem',
  fontWeight: 600,
}))

export const Description = styled.p(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.4rem',
  fontWeight: 500,
  textAlign: 'center',
}))

export const FeatureList = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  display: 'flex',
  flexDirection: 'column',
  margin: `${theme.space['24']} 0`,
  padding: theme.space['4'],
  width: '100%',
}))

export const FeatureItem = styled.div(({ theme }) => ({
  '@media (min-width: 400px)': {
    justifyContent: 'center',
  },
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'flex-start',
  padding: theme.space['8'],
}))

export const FeatureIcon = styled(DefaultIcon)(({ theme }) => ({
  color: theme.colors.black800,
  flexShrink: 0,
}))

export const FeatureText = styled.span(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.4rem',
  fontWeight: 600,
}))

export const FeatureSeparator = styled.hr(({ theme }) => ({
  backgroundColor: theme.colors.gray300,
  border: 'none',
  height: '0.1rem',
  margin: 0,
  padding: 0,
  width: '100%',
}))

export const ButtonIcon = styled(DefaultIcon)(({ theme }) => ({
  color: theme.colors.white,
  display: 'flex',
}))

export const SecurePayment = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'center',
  marginBottom: theme.space['12'],
}))

export const SecurePaymentText = styled.span(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.4rem',
  fontWeight: 500,
}))

export const StripeLogo = styled.img({
  height: '1.6rem',
  width: 'auto',
})
